import { D2CSiteContentSlot, } from '../enums/d2c-site-content/d2c-site-content-slot.enum';
import { D2CSourceApp } from '../enums/d2c-source-app/d2c-source-app.enum';
/**
 * The fields each site actually shows. The ERP editor offers only these, so
 * staff never edit something their site does not render. Adding a field here
 * goes together with rendering it on that site.
 */
export const D2C_SITE_CONTENT_FIELDS = {
    [D2CSourceApp.JEJURO]: {
        [D2CSiteContentSlot.BUSINESS_PROFILE]: [
            'tradeName',
            'registrationNumber',
            'representative',
            'mailOrderNumber',
            'address',
            'phone',
            'fax',
            'email',
            'rentalOperators',
            'copyright',
        ],
        [D2CSiteContentSlot.CONTACT_PROFILE]: [
            'kakaoChannelUrl',
            'instagramUrl',
            'facebookUrl',
            'youtubeUrl',
        ],
    },
    [D2CSourceApp.GALAXY]: {
        [D2CSiteContentSlot.BUSINESS_PROFILE]: [
            'tradeName',
            'representative',
            'registrationNumber',
            'mailOrderNumber',
            'address',
            'phone',
            'email',
            'copyright',
        ],
        [D2CSiteContentSlot.CONTACT_PROFILE]: ['whatsappUrl', 'lineUrl'],
    },
    [D2CSourceApp.FAMILY]: {
        [D2CSiteContentSlot.BUSINESS_PROFILE]: [
            'tradeName',
            'representative',
            'registrationNumber',
            'mailOrderNumber',
            'address',
            'privacyOfficer',
            'phone',
            'fax',
            'bankAccount',
            'copyright',
        ],
        [D2CSiteContentSlot.CONTACT_PROFILE]: [
            'csPhone',
            'csHours',
            'breakTime',
            'kakaoChannelUrl',
        ],
    },
    [D2CSourceApp.RAINBOW]: {
        [D2CSiteContentSlot.BUSINESS_PROFILE]: [
            'tradeName',
            'registrationNumber',
            'representative',
            'mailOrderNumber',
            'address',
            'phone',
            'email',
            'copyright',
        ],
        [D2CSiteContentSlot.CONTACT_PROFILE]: ['csPhone', 'csHours', 'breakTime'],
    },
};
const POPUP = {
    fields: [],
    itemFields: ['image', 'alt', 'link'],
    maxItems: 5,
};
/**
 * The image lists each site shows and which of their fields it renders. A site
 * without an entry for a slot has no such place on its home page.
 */
export const D2C_SITE_CONTENT_LISTS = {
    [D2CSourceApp.JEJURO]: {
        [D2CSiteContentSlot.HOME_HERO]: {
            fields: [],
            itemFields: [
                'image',
                'mobileImage',
                'eyebrow',
                'title',
                'titleLine2',
                'subtitle',
                'brightPhoto',
            ],
            maxItems: 8,
        },
        [D2CSiteContentSlot.HOME_BANNERS]: {
            fields: [],
            itemFields: ['image', 'mobileImage', 'eyebrow', 'title'],
            maxItems: 6,
        },
        [D2CSiteContentSlot.HOME_POPUP]: POPUP,
    },
    [D2CSourceApp.GALAXY]: {
        // One campaign image per language; without one the site shows its own
        // photo hero with translated text.
        [D2CSiteContentSlot.HOME_HERO]: {
            fields: [],
            itemFields: ['image', 'mobileImage', 'alt', 'lang'],
            maxItems: 6,
            langs: ['en', 'zh-TW'],
        },
        [D2CSiteContentSlot.HOME_POPUP]: Object.assign(Object.assign({}, POPUP), { itemFields: [...POPUP.itemFields, 'lang'], langs: ['en', 'zh-TW'] }),
    },
    [D2CSourceApp.FAMILY]: {
        [D2CSiteContentSlot.HOME_HERO]: {
            fields: ['headline', 'headlineLine2'],
            itemFields: ['image', 'mobileImage', 'alt'],
            maxItems: 1,
            single: true,
        },
        [D2CSiteContentSlot.HOME_BANNERS]: {
            fields: ['sectionTitle'],
            itemFields: ['image', 'mobileImage', 'alt', 'link'],
            maxItems: 1,
        },
        [D2CSiteContentSlot.HOME_POPUP]: POPUP,
    },
    [D2CSourceApp.RAINBOW]: {
        [D2CSiteContentSlot.HOME_HERO]: {
            fields: ['headline', 'headlineLine2'],
            itemFields: ['image', 'mobileImage', 'alt'],
            maxItems: 1,
            single: true,
        },
        [D2CSiteContentSlot.HOME_BANNERS]: {
            fields: ['sectionTitle'],
            itemFields: ['image', 'mobileImage', 'alt', 'link'],
            maxItems: 1,
        },
        [D2CSiteContentSlot.HOME_POPUP]: POPUP,
    },
};
/** The slots a site has, in the order the editor shows them. */
export const d2cSiteContentSlots = (site) => [
    D2CSiteContentSlot.BUSINESS_PROFILE,
    D2CSiteContentSlot.CONTACT_PROFILE,
    ...Object.keys(D2C_SITE_CONTENT_LISTS[site]),
];
export const D2C_SITE_CONTENT_SLOT_LABELS = {
    [D2CSiteContentSlot.BUSINESS_PROFILE]: '하단 회사 정보',
    [D2CSiteContentSlot.CONTACT_PROFILE]: '고객센터·연락 채널',
    [D2CSiteContentSlot.HOME_HERO]: '홈 첫 화면 이미지',
    [D2CSiteContentSlot.HOME_BANNERS]: '홈 배너',
    [D2CSiteContentSlot.HOME_POPUP]: '홈 팝업',
};
export const D2C_SITE_IMAGE_LIST_FIELD_LABELS = {
    sectionTitle: '구역 제목',
    headline: '문구 첫째 줄',
    headlineLine2: '문구 둘째 줄',
    image: 'PC 이미지',
    mobileImage: '모바일 이미지',
    alt: '이미지 설명',
    eyebrow: '작은 제목',
    title: '제목',
    titleLine2: '제목 둘째 줄',
    subtitle: '설명',
    brightPhoto: '밝은 사진',
    link: '누르면 갈 주소',
    lang: '언어',
    visible: '보이기',
    startAt: '보이기 시작',
    endAt: '보이기 끝',
};
export const D2C_SITE_LANG_LABELS = {
    en: '영어',
    'zh-TW': '중국어(번체)',
};
export const D2C_SITE_CONTENT_FIELD_LABELS = {
    tradeName: '상호',
    representative: '대표자',
    registrationNumber: '사업자등록번호',
    mailOrderNumber: '통신판매업 신고번호',
    address: '주소',
    privacyOfficer: '개인정보 보호책임자',
    phone: '대표 전화',
    fax: '팩스',
    email: '이메일',
    bankAccount: '입금 계좌',
    rentalOperators: '대여사업자',
    copyright: '저작권 문구',
    csPhone: '고객센터 전화',
    csHours: '운영 시간',
    breakTime: '점심시간',
    kakaoChannelUrl: '카카오톡 채널 주소',
    whatsappUrl: 'WhatsApp 주소',
    lineUrl: 'LINE 주소',
    instagramUrl: '인스타그램 주소',
    facebookUrl: '페이스북 주소',
    youtubeUrl: '유튜브 주소',
};
